import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=01351b96&scoped=true"
import script from "./history-list.vue?vue&type=script&lang=js"
export * from "./history-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01351b96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01351b96')) {
      api.createRecord('01351b96', component.options)
    } else {
      api.reload('01351b96', component.options)
    }
    module.hot.accept("./history-list.vue?vue&type=template&id=01351b96&scoped=true", function () {
      api.rerender('01351b96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/components/history-list.vue"
export default component.exports